/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo, useMemo, useState, useEffect } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { styled } from '@mui/material';
import { Item } from 'interface/project/projectInfo';
import { Stack } from '@mui/system';
import { useProject } from 'hooks/useProject';

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  borderRadius: '4px',
  // border: `solid 1px ${theme.palette.mind.grey.border2}`,
  backgroundColor: theme.palette.mind.custom.white,
  marginBottom: '10px',
  marginRight: 0,
  marginLeft: 0,
  '&:first-of-type': {
    marginTop: '10px',
  },
  color: theme.palette.mind.black.A0,
  '& .MuiFormControlLabel-label': {
    fontSize: 13,
    fontWeight: 400,
  },
  '&:active': {
    border: `0px solid ${theme.palette.mind.blue.azul}`,
  },
}));
const StyledRadio = styled(Radio)(({ theme }) => ({
  color: theme.palette.mind.grey.border2,
}));

interface ISurveyRadioBoxProps {
  id: string;
  items: Item[];
  type: string;
  handleNext: (_type: string, _surveyId: string, _info: any) => void;
  setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  surveyType: 'survey' | 'surveyAdd';
  handleNextButton?: () => void;
}

function SurveyRadioBox({
  id,
  items,
  type,
  handleNext,
  setIsDisabled,
  surveyType,
  handleNextButton,
}: ISurveyRadioBoxProps): JSX.Element {
  const { progressInfo, surveyResultList, surveyInfoResultList } = useProject();
  const resultList = surveyType === 'surveyAdd' ? surveyResultList : surveyInfoResultList;
  const buttonInfo = useMemo(() => {
    return resultList?.[progressInfo]?.choiceResultList || [''];
  }, [resultList, progressInfo]);
  const [value, setValue] = useState('');
  useEffect(() => {
    setValue(buttonInfo?.[0] || '');
  }, [buttonInfo]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const tmpValue = (event.target as HTMLInputElement).value;
    if (tmpValue) {
      setValue(tmpValue);
      setTimeout(() => {
        handleNext(type, id, tmpValue);
        if (handleNextButton) {
          setTimeout(() => {
            handleNextButton();
          }, 300);
        }
      }, 200);
    }
  };

  useEffect(() => {
    setIsDisabled(value === '');
  }, [setIsDisabled, value]);

  return (
    <Stack direction="column">
      <FormControl sx={{ display: 'flex', flex: 1 }}>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          value={value}
          onChange={handleChange}
          defaultValue=""
        >
          {items.map(item => (
            <StyledFormControlLabel key={item.id} value={item.id} control={<StyledRadio />} label={item.content} />
          ))}
        </RadioGroup>
      </FormControl>
    </Stack>
  );
}

export default memo(SurveyRadioBox);
